import { localTime } from '@helpers';
import { DashboardOverviewDateRange } from '@reducers/v2/dashboard/types';

export const dashboardOverviewDateRangeLabels = {
  [DashboardOverviewDateRange.SEVEN_DAYS]: '7 Days',
  [DashboardOverviewDateRange.LAST_WEEK]: 'Last Week',
  [DashboardOverviewDateRange.CURRENT_MONTH]: localTime().locale('en').format('MMMM'),
  [DashboardOverviewDateRange.CURRENT_YEAR]: localTime().locale('en').format('YYYY'),
} as const;

export const dashboardOverviewExtendedDateRangeLabels = {
  [DashboardOverviewDateRange.SEVEN_DAYS]: '7 Days',
  [DashboardOverviewDateRange.YESTERDAY]: 'Yesterday',
  [DashboardOverviewDateRange.THIS_WEEK]: 'This Week',
  [DashboardOverviewDateRange.LAST_WEEK]: 'Last Week',
  [DashboardOverviewDateRange.CURRENT_MONTH]: localTime().locale('en').format('MMMM'),
  [DashboardOverviewDateRange.PREVIOUS_MONTH]: localTime().subtract(1, 'month').locale('en').format('MMMM'),
  [DashboardOverviewDateRange.CURRENT_YEAR]: localTime().locale('en').format('YYYY'),
  [DashboardOverviewDateRange.PREVIOUS_YEAR]: localTime().subtract(1, 'year').locale('en').format('YYYY'),
  [DashboardOverviewDateRange.CUSTOM]: 'Custom',
} as const;
